import { useMemo } from "react"
import _ from "lodash"
import { EXTENSION_NAME } from "../../constants"
import { useExtension } from "hooks/extension/useExtension"

interface IExternalLink {
  externalLink: string
}

export const useExternalLink = (): IExternalLink => {
  const { extensionConfig } = useExtension()

  const externalLink = useMemo(() => {
    return _.get(
      extensionConfig,
      `${EXTENSION_NAME}.options.externalLink`,
      ""
    ) as string
  }, [extensionConfig])

  return { externalLink }
}
